import React from "react"
import Sku from "./Sku"
import Styles from "./SkuGrid.module.scss"

// takes in an Array of Skus

const SkuGrid = props => {
  const { title, Skus, CenterTheWraps } = props

  return (
    <section className={Styles.skugrid}>
      <h3 className={Styles.title}>{title}</h3>
      <div
        className={Styles.grid}
        style={{ justifyContent: `${CenterTheWraps ? "center" : null}` }}
      >
        {Skus.map(sku => {
          const { id, name, price, images, sizes } = sku
          return (
            <Sku
              key={id}
              id={id}
              name={name}
              price={price}
              images={images}
              sizes={sizes}
            />
          )
        })}
      </div>
    </section>
  )
}

export default SkuGrid
